import React from "react";
import { getDynamicLogo } from './getDynamicLogo';
import CircularProgress from "@mui/material/CircularProgress";
function Loader({ loading }) {
  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "var(--themeBackgroundColor, #fdfdfd)",
        zIndex: 9999,
        backdropFilter: "blur(4px)", // Modern blur effect
      }}
    >
      <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
        <CircularProgress
          style={{ width: "100%", height: "100%", color: "var(--themePrimaryColor, #DA6E0B)" }}
          thickness={1}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={getDynamicLogo()}
            style={{ width: "80%", height: "80%", objectFit: "contain" }}
            alt="Loading"
          />
        </div>
      </div>
    </div>
  );
}

export default Loader;
